// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"3c70f324","707":"53d6cc10","796":"42c59250","822":"58f37600"}[chunkId] + ".chunk.js";
};